module.exports = __webpack_public_path__ + "static/media/twin.b6489d41.png";